/**
 * @file reducers/Video/reducer.js
 * @copyright 2020 CBC/Radio-Canada. All rights reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { page_initial_data } from "../Page/reducer";
import { setData, setDataWithErrorMessage } from "./util";

export const initialVideoState = {
    currentClip: {},
    trendingClips: setData(),
    curatedPlaylist: setData(),
    moreFromBaseSection: setData(),
};

const videoSlice = createSlice({
    name: "video",
    initialState: initialVideoState,
    reducers: {
        // Current Clip
        current_clip_update: (state, action) => ({
            ...state,
            currentClip: action.payload,
        }),
        // Trending Clips
        trending_update: (state, action) => ({
            ...state,
            trendingClips: setData(action.payload),
        }),
        trending_error: (state, action) => ({
            ...state,
            trendingClips: setDataWithErrorMessage(action.payload),
        }),
        // Curated Playlist
        curated_playlist_update: (state, action) => ({
            ...state,
            curatedPlaylist: setData(action.payload),
        }),
        curated_playlist_error: (state, action) => ({
            ...state,
            curatedPlaylist: setDataWithErrorMessage(action.payload),
        }),
        // More From Base Section
        more_from_base_section_update: (state, action) => ({
            ...state,
            moreFromBaseSection: setData(action.payload),
        }),
        more_from_base_section_error: (state, action) => ({
            ...state,
            moreFromBaseSection: setDataWithErrorMessage(action.payload),
        }),
    },
    extraReducers: (builder) => {
        // Reset current, trending & more during page_initial_data
        builder.addCase(page_initial_data, (state) => {
            state.currentClip = initialVideoState.currentClip;
            state.trendingClips = initialVideoState.trendingClips;
            state.moreFromBaseSection = initialVideoState.moreFromBaseSection;
        });
    },
});

export const {
    current_clip_update: video_current_clip_update,
    trending_update: video_trending_update,
    trending_error: video_trending_error,
    curated_playlist_update: video_curated_playlist_update,
    curated_playlist_error: video_curated_playlist_error,
    more_from_base_section_update: video_more_from_base_section_update,
    more_from_base_section_error: video_more_from_base_section_error,
} = videoSlice.actions;

export default videoSlice.reducer;
